<template>
  <stack class="site-page scrollbar">
    <slot />
  </stack>
</template>

<script>
import Stack from "@/components/layout/common/Stack.vue";
export default {
  components: { Stack },
};
</script>
